import React from 'react';

import styles from './DevStatusBanner.module.css';

interface DevStatusBannerProps {
  branch?: string;
  buildAuthor?: string;
  buildId?: string;
  buildUrl?: string;
  environment: string;
}

export const DevStatusBanner = (props: DevStatusBannerProps) => {
  return (
    <div className={styles.container}>
      <dl className={styles.list}>
        <dt className={styles.key}>Environment</dt>
        <dd className={styles.value}>{props.environment}</dd>
        <dt className={styles.key}>Branch</dt>
        <dd className={styles.value}>{props.branch}</dd>
        <dt className={styles.key}>Build</dt>
        <dd className={styles.value}>
          <a href={props.buildUrl} target="_blank" rel="noreferrer" className={styles.link}>
            {props.buildId}
          </a>
        </dd>
        <dt className={styles.key}>Author</dt>
        <dd className={styles.value}>{props.buildAuthor}</dd>
      </dl>
    </div>
  );
};
